<div class="container indent-background">
  <div class="contact-info">
    <p class="phone mobile">
      Store Phone Number:<br><a href="tel:6304412920">630-441-2920</a>
    </p>
    <p>
      Email:<br><a href="mailto:info@inkfectioncollection.com">info@inkfectioncollection.com</a>
    </p>
    <p>
      <a href="https://www.facebook.com/inkfectioncollection/" target="_new">Facebook</a> |
      <a href="https://www.instagram.com/inkfectioncollection/" target="_new">Instagram</a> | 
      <a href="https://www.etsy.com/shop/INKfectionCollection" target="_new">Etsy</a>
    </p>
  </div>
</div>
